export default __webpack_public_path__ + "static/media/ci.133adff8.svg";